export const EQUIPMENTS_URI: string = 'equipments';
export const ORDER_HISTORY_URI: string = 'history';
